/**
 * Pallet progress badge
 * Install as: assets/pallet-progress-badge.js
 *
 * Reads the customer's live cart and reports progress toward the pallet
 * minimum, scoped to whichever collection the section is configured with.
 * Purely informational — does not add or remove anything from the cart.
 *
 * Because customers add products via each product page's own Add to cart
 * button (not through this widget), this script re-checks the cart:
 *   1. once on page load
 *   2. shortly after any /cart/add form on the page is submitted
 *   3. on a light interval while the tab is visible, to catch AJAX add
 *      buttons that don't use a plain form submit
 */
(function () {
  'use strict';

  var CACHE_KEY_PREFIX = 'palletBadgeVariantIds:';
  var CACHE_TTL_MS = 10 * 60 * 1000; // 10 minutes
  var POLL_MS = 8000;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var root = document.querySelector('.pallet-badge');
    if (!root) return;

    var palletSize = parseInt(root.dataset.palletSize, 10) || 40;
    var collectionHandle = root.dataset.collectionHandle;
    var textEl = root.querySelector('[data-pallet-text]');
    var stackEl = root.querySelector('[data-pallet-stack]');
    var crates = buildCrates(stackEl, palletSize);

    if (!collectionHandle) {
      textEl.textContent = 'Pallet progress unavailable (no collection configured).';
      return;
    }

    getVariantIds(collectionHandle)
      .then(function (variantIds) {
        refresh(variantIds);

        document.addEventListener('submit', function (e) {
          var form = e.target;
          if (form && form.action && form.action.indexOf('/cart/add') > -1) {
            setTimeout(function () { refresh(variantIds); }, 1200);
          }
        });

        var poll = function () {
          if (document.visibilityState === 'visible') {
            refresh(variantIds);
          }
        };
        setInterval(poll, POLL_MS);
      })
      .catch(function () {
        textEl.textContent = 'Could not load pallet progress.';
      });

    function refresh(variantIds) {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var total = 0;
          cart.items.forEach(function (line) {
            if (variantIds[String(line.variant_id)]) {
              total += line.quantity;
            }
          });
          render(total);
        })
        .catch(function () {
          textEl.textContent = 'Could not load pallet progress.';
        });
    }

    function render(total) {
      var filled = Math.min(total, palletSize);
      var complete = total >= palletSize;

      crates.forEach(function (crate, i) {
        crate.classList.toggle('is-filled', i < filled);
        crate.classList.toggle('is-complete', complete && i < filled);
      });

      if (complete) {
        textEl.textContent = 'Pallet complete — ' + total + '/' + palletSize + ' drinks in your cart.';
      } else {
        textEl.textContent = total + '/' + palletSize + ' drinks in your cart — add ' + (palletSize - total) + ' more to unlock checkout.';
      }
    }
  }

  function buildCrates(stackEl, count) {
    var crates = [];
    for (var i = 0; i < count; i++) {
      var crate = document.createElement('div');
      crate.className = 'pallet-badge__crate';
      stackEl.appendChild(crate);
      crates.push(crate);
    }
    return crates;
  }

  function getVariantIds(handle) {
    var cacheKey = CACHE_KEY_PREFIX + handle;
    try {
      var cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && cached.expiresAt > Date.now()) {
        return Promise.resolve(cached.variantIds);
      }
    } catch (e) {
      // Ignore storage errors and refetch.
    }

    return fetchAllProducts(handle).then(function (products) {
      var variantIds = {};
      products.forEach(function (product) {
        (product.variants || []).forEach(function (variant) {
          variantIds[String(variant.id)] = true;
        });
      });

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({
          variantIds: variantIds,
          expiresAt: Date.now() + CACHE_TTL_MS
        }));
      } catch (e) {
        // Ignore storage errors — just won't cache this run.
      }

      return variantIds;
    });
  }

  function fetchAllProducts(handle) {
    var all = [];
    function fetchPage(page) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          all = all.concat(products);
          if (products.length === 250) {
            return fetchPage(page + 1);
          }
          return all;
        });
    }
    return fetchPage(1);
  }
})();